module.exports = __webpack_public_path__ + "img/LAPTOP.d59a192e.svg";